module.exports = __webpack_public_path__ + "static/tablet-598ab56e3961e9094d915cfcc5f29228.jpg";